module.exports = __webpack_public_path__ + "static/media/invoicetemplatepdfFile.fec67731.jpg";